import { Link } from "react-router-dom";

import styled from "@emotion/styled";

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;

  border-radius: ${p => p.theme.radii.medium};
  background-color: ${p => p.theme.colors.background};

  transition:
    background-color 0.3s ease-in-out,
    fill 0.3s ease-in-out;

  svg {
    transition: fill 0.3s ease-in-out;
  }

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    width: 52px;
    height: 52px;
  }
`;

export const ProxyName = styled.p`
  font-size: ${p => p.theme.fontSizes.m};
  font-weight: ${p => p.theme.fontWeight.medium};

  color: ${p => p.theme.colors.black};

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    font-size: ${p => p.theme.fontSizes.l};
  }
`;

export const StyledLinkBlog = styled(Link)`
  text-decoration: none;

  min-width: 148px;
  width: 100%;
  height: 104px;
  gap: 6px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-color: ${p => p.theme.colors.white};
  border-radius: 24px;
  cursor: pointer;

  transition: background-color 0.3s ease-in-out;
  -webkit-tap-highlight-color: transparent;

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    min-width: auto;
    max-width: 180px;
    width: 100%;
    height: 140px;

    gap: ${p => p.theme.space[3]}px;
  }

  svg {
    fill: ${props => props.theme.colors.black};
  }

  :hover,
  :active {
    div {
      background-color: ${props => props.theme.colors.black};
    }

    svg {
      fill: ${props => props.theme.colors.accent.green};
    }
  }
`;
